import { ethers } from 'ethers';
import useRaffles from '../hooks/useRaffles';
import { formatEther } from '../util';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';
import humanizeDuration from 'humanize-duration';

const countdownRenderer = ({ total, completed }) => {
  if (completed) return '';

  return humanizeDuration(total, { language: 'en', largest: 2, round: true });
};

const RaffleDetailsTab = ({ raffleKey }) => {
  const raffle = useRaffles(raffleKey);

  const [raffleStarted, setRaffleStarted] = useState(false);
  const [raffleEnded, setRaffleEnded] = useState(false);

  const [raffleStart, setRaffleStart] = useState(new Date(0));
  const [raffleEnd, setRaffleEnd] = useState(new Date());

  useEffect(() => {
    if (raffle) {
      setRaffleStart(new Date(raffle.start_time));
      setRaffleEnd(new Date(raffle.end_time));
    }
  }, [raffle]);

  useEffect(() => {
    setRaffleStarted(raffleStart.getTime() < Date.now());
    setRaffleEnded(raffleEnd.getTime() < Date.now());
  }, [raffleStart, raffleEnd]);

  const raffleActive = raffleStarted && !raffleEnded;

  const ticketPrice =
    !raffle.disable_ticket_sales &&
    ethers.constants.WeiPerEther.mul(raffle.ticket_price);

  return (
    <>
      <div className="row">
        <div className="col-12 col-md-6 mb-2">
          {raffleActive ? (
            <>
              <p className="fs-3 fw-bold mb-1">Ending In:</p>
              <p>
                <Countdown
                  date={raffleEnd}
                  days
                  onComplete={() => setRaffleEnded(true)}
                  renderer={countdownRenderer}
                />
              </p>
            </>
          ) : raffleEnded ? (
            <>
              <p className="fs-3 fw-bold mb-1 text-muted">Raffle Ended</p>
            </>
          ) : (
            <>
              <p className="fs-3 fw-bold mb-1">Starting In:</p>
              <p>
                <Countdown
                  date={raffleStart}
                  days
                  onComplete={() => setRaffleStarted(true)}
                  renderer={countdownRenderer}
                />
              </p>
            </>
          )}
        </div>
        {!raffle.disable_ticket_sales && (
          <div className="col-12 col-md-6">
            <p className="fs-3 fw-bold mb-1">Ticket Cost:</p>
            <p>{formatEther(ticketPrice)} Rainbows</p>
          </div>
        )}
      </div>
      <p className="fs-3 fw-bold">The Rules</p>
      <ol>
        {raffle.rules.map((s, i) => (
          <li key={i} className="mb-2 fw-bold">
            <p className="fw-normal">{s}</p>
          </li>
        ))}
      </ol>
    </>
  );
};

export default RaffleDetailsTab;
